import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard implements CanActivate, CanActivateChild {
  ua: string = navigator.userAgent;

  constructor(private router: Router) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const hostname = window.location.hostname;
    if (
      (!state.url.includes('my-documents') &&
        !state.url.includes('hr-documentation') &&
        (this.ua.includes('iPhone') ||
          this.ua.includes('iPad') ||
          this.ua.includes('Android') ||
          this.ua.includes('Windows Phone') ||
          this.ua.includes('BlackBerry') ||
          this.ua.includes('Windows Mobile') ||
          this.ua.includes('Symbian') ||
          this.ua.includes('Tizen') ||
          this.ua.includes('WebOS') ||
          this.ua.includes('Kindle')))
    ) {
      this.router.navigate(['/open-mobile-app-or-prod']);
      return false;
    }
    return true;
  }

  async canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(next, state);
  }
}
